import { Button } from '@/design-system';
import { OrganizationBillingSchema } from '@/types/schema';

export function BillingInfoCardActions(props: {
  setupPaymentTrigger: () => void;
  isSetupPaymentMutating: boolean;
  currentOrganization: OrganizationBillingSchema;
}) {
  const updatePaymentMethod = props.currentOrganization.connected_to_stripe &&
    props.currentOrganization.connected_to_metronome &&
    !!props.currentOrganization.payment_method && (
      <div>
        <Button
          color="secondary"
          variant="outlined"
          disabled={props.isSetupPaymentMutating}
          onClick={(e) => {
            e.preventDefault();
            props.setupPaymentTrigger();
          }}
          loading={props.isSetupPaymentMutating}
        >
          Update
        </Button>
      </div>
    );

  return updatePaymentMethod;
}
